import { useMemo } from "react";

export const useIsScreenSharingAvailable = () => {
  const isScreenSharingAvailable = useMemo(() => {
    return typeof navigator.mediaDevices.getDisplayMedia == "function";
  }, []);

  return isScreenSharingAvailable;
};
